import React from "react";
import vaisnavaPdf from "../../Assets/Boys premarital course.pdf";
import { FiArrowLeft } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const VaisnavaCourse = () => {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen w-full items-start justify-center bg-gradient-to-br from-purple-100 via-pink-100 to-yellow-100 p-6">
      <div className="relative mt-20 w-[90%] transform rounded-2xl bg-white p-6 shadow-2xl">
        <button
          onClick={() => navigate(-1)}
          className="absolute left-6 top-6 flex items-center space-x-2 text-gray-700 hover:text-gray-900"
        >
          <FiArrowLeft size={24} />
          <span className="text-lg font-medium">Back</span>
        </button>
        <div className="mb-6 flex items-center justify-center">
          <h2 className="text-2xl font-bold text-gray-800">
            Vaisnava Course Preview
          </h2>
        </div>
        <div className="overflow-hidden rounded-xl border-2 border-gray-200 shadow-inner">
          <embed
            src={vaisnavaPdf}
            type="application/pdf"
            className="h-[80vh] w-full"
          />
        </div>
      </div>
    </div>
  );
};

export default VaisnavaCourse;
